import { memo } from 'react'
import { ContactsBlock } from 'resources/projects/projectsList/ContactsBlock'
import type { ContactType } from 'types/contacts'

const ContactsCell = ({ contactsData }: { contactsData: ContactType[] | undefined }) => {
  return <ContactsBlock contactsData={contactsData} />
}

export default memo(ContactsCell)
